module.exports = __webpack_public_path__ + "img/ti7.acacfd9b.png";